import type { AccessibilitySettings } from '../types'

interface Props {
  settings: AccessibilitySettings
  onChange: (settings: AccessibilitySettings) => void
}

export function AccessibilityToolbar({ settings, onChange }: Props) {
  return (
    <div className="accessibility-toolbar" aria-label="Opciones de accesibilidad">
      <button
        type="button"
        className={settings.concentrationMode ? 'control-button active' : 'control-button'}
        aria-pressed={settings.concentrationMode}
        onClick={() => onChange({ ...settings, concentrationMode: !settings.concentrationMode })}
      >
        Concentración
      </button>
      <button
        type="button"
        className="control-button"
        onClick={() => onChange({ ...settings, textScale: Math.min(1.3, settings.textScale + 0.1) })}
        aria-label="Aumentar tamaño del texto"
      >
        A+
      </button>
      <button
        type="button"
        className="control-button"
        onClick={() => onChange({ ...settings, textScale: Math.max(0.9, settings.textScale - 0.1) })}
        aria-label="Disminuir tamaño del texto"
      >
        A−
      </button>
      <button
        type="button"
        className={settings.soundEnabled ? 'control-button active' : 'control-button'}
        aria-pressed={settings.soundEnabled}
        onClick={() => onChange({ ...settings, soundEnabled: !settings.soundEnabled })}
      >
        Sonido
      </button>
      <button
        type="button"
        className={settings.celebrationsEnabled ? 'control-button active' : 'control-button'}
        aria-pressed={settings.celebrationsEnabled}
        onClick={() => onChange({ ...settings, celebrationsEnabled: !settings.celebrationsEnabled })}
      >
        Celebraciones
      </button>
    </div>
  )
}
